import { BaseEntity } from 'yt-ng-framework';

export class KomitentKontaktOsoba extends BaseEntity {
    constructor(){
        super();
    }
    KomitentID: number = null;
    OsobaID: string = null;
    Opis: string = null;
   

    Deserialize(input: any){
        this.ID = input.ID;
        this.KomitentID = input.KomitentID;
        this.OsobaID = input.OsobaID;
        this.Opis = input.Opis;        
        return this;
    }

    Serialize(input: KomitentKontaktOsoba){
        return input;
    }
}